export default __webpack_public_path__ + "static/media/where-neck.015dfa2d.jpg";